require('./transferMoneyStep2.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { FormattedText } = require('core/i18n').i18n;
// @ constants
const { CARD_TRANSFER_MONEY_ID } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
// @utilities
const { nonNumericFilter } = require('utilities/stringHelper');
const { getFormattedString } = require('utilities/currencyHelper');

class TransferMoneyStep2 extends React.Component {
    render() {
        const { immCardTransferMoney, immCard, accountsIndexes, immAccounts } = this.props;
        const productNumber = immCard.getIn(['contract', 'product']);
        const contractNumber = immCard.getIn(['contract', 'number']);
        const amount = immCardTransferMoney.get('amount');
        const currency = immCardTransferMoney.get('currency');
        const operationParams = {
            ammount: `+${amount}`,
            currency,
            'destinationAccount': `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`,
            'pan': nonNumericFilter(immCard.get('number'))
        };
        const immAccount = immAccounts.get(accountsIndexes[0]);
        const alias = immAccount.get('iban').substr(-4);

        const injectedStrings = [
            getFormattedString({ amount, currency }),
            alias
        ];

        const commission = [
            getFormattedString({ amount: immCardTransferMoney.get('commission'), currency })
        ];

        return (
            <article className="transfer-money-step-two">
                <header className="transfer-money-step-two__header">
                    <FormattedText value="cardTransferMoney-confirmationTitle" className="transfer-money-step-two__title" />
                </header>
                <section className="transfer-money-step-two__content">
                    <div className="transfer-money-step-two__subtitle-container" >
                        <FormattedText value="cardTransferMoney-confirmationMessage" className="transfer-money-step-two__subtitle" injectedStrings={injectedStrings} />
                        <FormattedText value="cardTransferMoney-confirmationCommissionMessage" className="transfer-money-step-two__subtitle" injectedStrings={commission} />
                    </div>
                    <SignaturePattern
                        operationType={CARD_TRANSFER_MONEY_ID}
                        operationParams={operationParams}
                    />
                </section>
            </article>
        )
    }
}

TransferMoneyStep2.propTypes = {
    immCardTransferMoney: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    accountsIndexes: PropTypes.array.isRequired,
    immAccounts: PropTypes.object.isRequired
};

module.exports = TransferMoneyStep2;
